import { useQueryClient } from '@tanstack/react-query';
import React from 'react';

import { useSocketStore } from '../../store/useSocketStore';
import { queryKeys } from '../../queryKeys';

// Contact email verification happens from a link opened in another tab or
// device and lands on a public backend GET — nothing else tells a tab that
// already has the Terms of Use form open that the status just flipped.
export function useTermsOfUseSocket() {
  const { socket } = useSocketStore();
  const queryClient = useQueryClient();

  React.useEffect(() => {
    if (!socket) return;

    const invalidateTermsOfUse = () => {
      queryClient.invalidateQueries({
        exact: false,
        queryKey: queryKeys.termsOfUse.fetchOrgTermsOfUse._def,
      });
      queryClient.invalidateQueries({
        exact: false,
        queryKey: queryKeys.termsOfUse.fetchOrgTermsOfUseStatus._def,
      });
    };

    socket.on('terms-of-use:verified', invalidateTermsOfUse);

    return () => {
      socket.off('terms-of-use:verified', invalidateTermsOfUse);
    };
  }, [socket, queryClient]);
}
